export default __webpack_public_path__ + "static/media/logo_recodeme.9bd171d3.png";